import { useRef, useEffect, useState } from "react";
import dayjs from "dayjs";
import generatePDF from "react-to-pdf";

import { Box } from "@mui/material";

import { ReportPages } from "../../../../modules/reporting/Report";
import { uploadFileToStorage } from "../../../../../helpers/firebase";
import { getAccountId } from "../../../../../helpers/accountHelpers";

const SETTLE_DELAY_MS = 3000;

const ReportRenderer = ({ year, emissions, onUploaded, onError }) => {
  const targetRef = useRef(null);
  const [settled, setSettled] = useState(false);
  const hasStarted = useRef(false);
  const onUploadedRef = useRef(onUploaded);
  const onErrorRef = useRef(onError);
  onUploadedRef.current = onUploaded;
  onErrorRef.current = onError;

  const startDate = new Date(year, 0, 1);
  const endDate = new Date(year, 11, 31);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(true), SETTLE_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!settled || hasStarted.current) {
      return;
    }
    hasStarted.current = true;

    const generate = async () => {
      try {
        const pdf = await generatePDF(targetRef, {
          method: "build",
          page: { format: "letter" }
        });
        const blob = pdf.output("blob");
        const accountId = getAccountId();
        const storagePath = `${accountId}/reports/${year}/emissions-report.pdf`;
        const url = await uploadFileToStorage({
          path: storagePath,
          fileObject: blob,
          fileMetadata: { contentType: "application/pdf" },
          hasUserConfirmedUpload: true
        });
        onUploadedRef.current(url);
      } catch (e) {
        onErrorRef.current(e);
      }
    };

    generate();
  }, [settled, year]);

  const yearEmissions = (emissions || []).filter(({ date }) => {
    const emDate = date?.toDate ? date.toDate() : new Date(date);
    return dayjs(emDate).year() === year;
  });

  return (
    <Box
      style={{
        position: "absolute",
        left: "-9999px",
        top: 0,
        width: "816px",
        overflow: "hidden"
      }}
    >
      <Box ref={targetRef}>
        <ReportPages
          startDate={startDate}
          endDate={endDate}
          emissions={yearEmissions}
          graphPeriod="year"
          pdfLoading={true}
        />
      </Box>
    </Box>
  );
};

export default ReportRenderer;
